import { v4 as uuid } from 'uuid';
import { DominoBuilderError, DominoBuilderErrorScope, DominoBuilderErrorSeverity, DominoBuilderErrorType, } from '../errors';
import { createDynamicSymbolProxy, getQualifiedSymbolId } from './symbols';
export class FlowSymbolTable {
    constructor() {
        this._symtab = new Map();
        this._symtab.set('global', {
            searchIndex: [],
            data: new Map(),
        });
        this.currentScopeId = 'global';
    }
    enterScope() {
        const scopeId = uuid();
        this._symtab.set(scopeId, {
            parent: this.currentScopeId,
            searchIndex: [],
            data: new Map(),
        });
        this.currentScopeId = scopeId;
        return scopeId;
    }
    get _currentScope() {
        return this._symtab.get(this.currentScopeId);
    }
    leaveScope() {
        this.currentScopeId = this._currentScope.parent;
    }
    setScopedSymbol(id, flowSymbol, scopeRef) {
        // ensure clean up of type index
        this.deleteScopedSymbol(id, scopeRef);
        this._symtab.get(scopeRef).data.set(id, flowSymbol);
    }
    getScopedSymbol(id, scopeRef) {
        const scope = this._symtab.get(scopeRef);
        return scope === null || scope === void 0 ? void 0 : scope.data.get(id);
    }
    addToSymbolSearchIndex(flowSymbol, scopeRef) {
        const scope = this._symtab.get(scopeRef);
        const symbols = scope.searchIndex.filter(sym => !(sym.primogenitor === flowSymbol.primogenitor &&
            getQualifiedSymbolId(sym) === getQualifiedSymbolId(flowSymbol)));
        symbols.push(flowSymbol);
        scope.searchIndex.push(flowSymbol);
        scope.searchIndex = symbols;
    }
    getSymbolsForSearchIndex(scopeRef) {
        let s = [];
        let scope = this._symtab.get(scopeRef);
        while (scope) {
            s = s.concat(scope.searchIndex);
            scope = this._symtab.get(scope.parent);
        }
        return s;
    }
    deleteScopedSymbol(id, scopeRef) {
        // deletion of directive actions could present some gnarly scope rearrangement situations, deferring this for now
        const scope = this._symtab.get(scopeRef);
        scope.data.delete(id);
        const symbols = scope.searchIndex.filter(s => s.primogenitor !== id);
        scope.searchIndex = symbols;
    }
    calculateEffectiveScope(scopeRef) {
        const effectiveScope = new Proxy({}, {
            get: (_target, symbol, _receiver) => {
                let s;
                let scope = this._symtab.get(scopeRef);
                while (scope && !s) {
                    if (scope.data.has(symbol)) {
                        s = scope.data.get(symbol);
                    }
                    scope = this._symtab.get(scope.parent);
                }
                return (s !== null && s !== void 0 ? s : createDynamicSymbolProxy({
                    id: symbol,
                    actionHandle: undefined,
                    type: undefined,
                    primogenitor: symbol,
                    lineNumber: -1,
                    errors: [
                        new DominoBuilderError(DominoBuilderErrorType.InvalidSymbolReference, DominoBuilderErrorScope.DESIGN, DominoBuilderErrorSeverity.ERROR, `'${symbol}' does not exist on type 'ActionResult'`, {
                            path: `Symbol::${symbol}`,
                        }),
                    ],
                    __deproxy: () => undefined,
                }));
            },
        });
        return effectiveScope;
    }
}
//# sourceMappingURL=FlowSymbolTable.js.map